import CheckmarkOrb from '@clearkit/icons/glyphs/CheckmarkOrb';

import { configurationNameForType } from '~/lib/configuration';

import styles from './styles.js';

const TabLabel = ({ service, connector, classes }) => {
  const name = configurationNameForType(service);

  if (connector) {
    return (
      <>
        <span className={classes.tabLabelPrimary}>
          Connected to {name}{' '}
          <div className="ml-1 text-gray-400">
            <CheckmarkOrb width="16px" height="16px" />
          </div>
        </span>
        <span className={classes.tabLabelSecondary}>{connector.name}</span>
      </>
    );
  } else {
    return (
      <div className={classes.tabDisconnectedLabelLine}>Connect to {name}</div>
    );
  }
};

TabLabel.propTypes = {
  service: PropTypes.string,
  connector: PropTypes.shape({
    name: PropTypes.string,
  }),
};

export default withStyles(styles)(TabLabel);
